import { createContext, useState } from 'react';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [queryOptions, setQueryOptions] = useState({});
    const [fetchedTraders, setFetchedTraders] = useState();
    const [isF3Entered, setIsF3Entered] = useState(false);
    const [sdrFilter, setSdrFilter] = useState({
        allCurrencies: false,
        currencies: [],
        otherFilters: {
            irs: {
                tradesUnder1kDv01: true
            },
            fxOption: {
                tradesUnder2DExpiry: true,
                tradesUnder10MnNotional: true
            }
        }
    });
    const [userPreferences, setUserPreferences] = useState(null);
    const [equityCtaTicker, setEquityCtaTicker] = useState();
    const [eqCtaStats, setEqCtaStats] = useState({});
    const [activeFxCtaPair, setActiveFxCtaPair] = useState();
    const [fxCtaTickers, setFxCtaTickers] = useState([]);
    const [fxCtaStats, setFxCtaStats] = useState({});
    const [ratesHighlights, setRatesHighlights] = useState([]);
    const [activeRatesCcy, setActiveRatesCcy] = useState();
    const [matchingCount, setMatchingCount] = useState({ MATCHING_AGENCY: 0, MATCHING_IDB: 0 });

    return <DataContext.Provider
        value={
            {
                queryOptions,
                setQueryOptions,
                fetchedTraders,
                setFetchedTraders,
                isF3Entered,
                setIsF3Entered,
                sdrFilter,
                setSdrFilter,
                userPreferences,
                setUserPreferences,
                equityCtaTicker,
                setEquityCtaTicker,
                eqCtaStats,
                setEqCtaStats,
                activeFxCtaPair,
                setActiveFxCtaPair,
                fxCtaTickers,
                setFxCtaTickers,
                fxCtaStats,
                setFxCtaStats,
                ratesHighlights,
                setRatesHighlights,
                activeRatesCcy,
                setActiveRatesCcy,
                matchingCount,
                setMatchingCount
            }}
    >
        {children}
    </DataContext.Provider>;
};
